/**
 * Dostep do sklepu Reduksa spoza drzewa komponentow.
 *
 * PO CO TO ISTNIEJE
 * -----------------
 * Prawie caly kod siega po stan przez `connect()` albo przez efekty sagi
 * (`put`, `select`) i TO JEST WLASCIWA DROGA. Ten modul jest wyjatkiem dla
 * jednego przypadku, w ktorym tamte sposoby nie dzialaja:
 *
 *     src/redux/settings/sagas.ts wysyla akcje z funkcji zwrotnych
 *     podpietych do `history.listen` i do nasluchu `resize`. Te funkcje
 *     wykonuja sie POZA generatorem sagi, wiec `put()` nie ma tam dostepu
 *     do kanalu sagi.
 *
 * DLACZEGO NIE `import { store } from '../index'`
 * ----------------------------------------------
 * Bo to tworzylo cykl: index -> redux/sagas -> settings/sagas -> index.
 * Ten modul nie importuje niczego z aplikacji, wiec nie moze byc czescia
 * cyklu. Szczegoly w `src/config/historia.ts`.
 *
 * KOLEJNOSC MA ZNACZENIE
 * ----------------------
 * `ustawSklep` wola `src/index.tsx` zaraz po utworzeniu sklepu, a PRZED
 * uruchomieniem sag. Gdyby ktos siegnal po sklep wczesniej, dostanie
 * wyrazny blad zamiast `undefined` wedrujacego dalej po cichu.
 */
import { Store } from 'redux';

let sklep: Store | null = null;

/** Zapamietuje sklep. Wolane raz, z `src/index.tsx`. */
export function ustawSklep(nowy: Store): void {
    sklep = nowy;
}

/**
 * Oddaje sklep. Rzuca, gdy wywolane przed `ustawSklep` — cichy `undefined`
 * objawilby sie dopiero kilka warstw dalej, jako niezrozumialy blad.
 */
export function pobierzSklep(): Store {
    if (!sklep) {
        throw new Error(
            'Sklep Reduksa nie jest jeszcze gotowy. ' +
            'ustawSklep() wola src/index.tsx przy starcie aplikacji — ' +
            'siegniecie po sklep przed tym momentem jest bledem kolejnosci.',
        );
    }
    return sklep;
}
